export class Force24Helper {
  static updateTracker = (checkOutAmount) => {
    try {
      let f24 = () => {};

      f24('event', 'wa_page_view', {
        loc: window.location.origin,
        CheckOutAmount: checkOutAmount
      });
    } catch {
      console.log('Error occured in force24 script');
    }
  };

  static setTracker = () => {
    try {
      let f24 = () => {};
      (function (f, o, r, c, e, _2, _4) {
        (f.Force24Object = e),
          (f[e] =
            f[e] ||
            function () {
              (f[e].q = f[e].q || []), f[e].q.push(arguments);
            }),
          (f[e].l = 1 * new Date()),
          (_2 = o.createElement(r)),
          (_4 = o.getElementsByTagName(r)[0]),
          (_2.async = !0),
          (_2.src = c),
          _4.parentNode.insertBefore(_2, _4);
      })(
        window,
        document,
        'script',
        'https://static.websites.data-crypt.com/scripts/activity/v3/inject-v3.min.js',
        'f24'
      );

      f24('config', 'set_tracking_id', '1175f6d1-bb77-4901-8e51-231dc0c84b57');

      f24('config', 'set_client_id', 'a6e0529e-a5d2-44c0-89ff-bae011a2204c');
    } catch {
      console.log('Error occured in force24 script');
    }
  };
}
